import { Guid } from '@web/utils';
import { PublicFaqQuestion } from './public-faq-question';

export class PublicFaqCategory {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      slug: string;
      questions: PublicFaqQuestion[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get questions(): PublicFaqQuestion[] {
    return this.data.questions;
  }
}
